/* eslint-disable */
import { DEFAULT_SCENARIO } from "../tabs/PersonWorkspace";

// Additive migration of saved records to the unified data model. Idempotent.
export function migrateClients(data) {
  const out = {};
  for (const [key, c] of Object.entries(data || {})) {
    const accounts = (c.accounts || []).map(a => ({
      ...a,
      is_annuity: !!a.is_annuity,
      is_inherited_ira: !!a.is_inherited_ira,
      ...(a.is_annuity ? { annuity_type: a.annuity_type || "income" } : {}),
      ...(a.is_inherited_ira ? { beneficiary_type: a.beneficiary_type || "edb", dob_selection: a.dob_selection ?? 0 } : {}),
    }));
    out[key] = {
      ...c,
      is_prospect: !!c.is_prospect,
      accounts,
      scenario: { ...DEFAULT_SCENARIO, ...(c.scenario || {}), allocs: { ...DEFAULT_SCENARIO.allocs, ...(c.scenario?.allocs || {}) }, fia: { ...DEFAULT_SCENARIO.fia, ...(c.scenario?.fia || {}) } },
    };
  }
  return out;
}

